
import {Component, Vue} from "vue-property-decorator";
import {gecisDugmesiAcik, YETKI_GECISI_YOLU} from "@/components/yetki-gecisi/yetkiGecisi";

@Component
export default class YetkiGecisiDugmesi extends Vue {
  // Karar /ben'den (mod, yöneticilik, sunucunun gecis_dugmesi'si; geri alınmış büroda da true); bayat oturumda ve yetki hatasında yok.
  get gorunur(): boolean {
    return gecisDugmesiAcik(this.$store.state.user);
  }

  gecisSayfasinaGit() {
    this.$router.push(YETKI_GECISI_YOLU);
  }
}
